import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { GetTransactionErrorsInput, TransactionErrorByIdQuery, TransactionErrorModel, Scalars } from '../gql-types.generated';


// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_MESSAGING_LOG_BY_ID = gql`
    query transactionErrorById($input: GetTransactionErrorsInput!) {
        transactionErrors (input: $input) {
            nodes {
                id
                documentId
                description
                documentReferenceId
                messageType
                originalFileName
                purchaseOrderNumber
                processName
                rawMessage
                status
                createdTime
                resolvedTime
                resolvedByName
                client {
                    id
                    name
                }
                partner {
                    id
                    name
                }
                clientPartner {
                    id
                }
                transaction {
                    id
                    name
                    direction
                    normalizedDocumentType
                }
                category {
                    id
                    name
                }
                notes {
                    createdBy
                    createdByName
                    createdTime
                    header
                    id
                    lastModifiedBy
                    lastModifiedByName
                    lastModifiedTime
                    note
                    parentId
                }
            }
        }
    }
`;

export const queryErrorLogById = async (
    client: ApolloClient<NormalizedCacheObject>,
    id: Scalars['UUID']
): Promise<TransactionErrorModel[] | undefined> => {
    const {data, errors} = await client.query<TransactionErrorByIdQuery>({
        variables: {
            input: {
                id: id
            }
        },
        query: QUERY_MESSAGING_LOG_BY_ID,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.transactionErrors?.nodes as TransactionErrorModel[];
    
};